import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LanguageSelector from '../../../LanguageSelector';
import { ONCOCARE_CALCULATOR_PATH, TRAVEL_CALCULATOR_PATH } from '../../../../constants/routes';

import EfesLogo from '../../../../img/efesLogoDarkWithText.png';
import FHHLogo from '../../../../img/footer/fhh.svg';
import CBLogo from '../../../../img/footer/cb.svg';
import BureauLogo from '../../../../img/footer/bureau.svg';
import FinInfoLogo from '../../../../img/footer/fininfo.svg';
import ABCLogo from '../../../../img/footer/abc.png';

import useStyles from '../makeStyles';

const TopFooter = ({ handleChangeLanguage, language }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.topFooterContainer}>
      <div className={classes.topFooterParentBox}>
        <div className={classes.item}>
          <img src={EfesLogo} alt="logo" className={classes.efesLogo} />
        </div>
        <div className={cn(classes.item, classes.mobileLanguage)}>
          <LanguageSelector
            onLanguageChange={(value) => handleChangeLanguage(value)}
            selectedLanguage={language}
            withIcon
          />
        </div>
        <div className={cn(classes.item, classes.mobileButtonGroup)}>
          {/* @TODO will be open in the latter */}
          {/* <ButtonGroup /> */}
        </div>
        <div className={classes.links}>
          <div className={cn(classes.item, classes.calculators)}>
            <p>{t('footer.calculators')}</p>
            <ul>
              <li>
                <Link to={TRAVEL_CALCULATOR_PATH}>{t('footer.travel')}</Link>
              </li>
            </ul>
            <ul>
              <li>
                <Link to={ONCOCARE_CALCULATOR_PATH}>{t('footer.oncoCare')}</Link>
              </li>
            </ul>
          </div>
          <div className={classes.item}>
            <p>{t('footer.contractSigning')}</p>
            <ul>
              <li>
                <Link to="/create-contract/travel/signer">{t('footer.travel')}</Link>
              </li>
            </ul>
            <ul>
              <li>
                <Link to="/create-contract/oncocare/signer">{t('footer.oncoCare')}</Link>
              </li>
            </ul>
          </div>
          <div className={cn(classes.item, classes.compensationItem)}>
            <p>{t('footer.other')}</p>
            <ul>
              <li>
                <Link to="/create-claim/casco/searchApplicant">{t('footer.applyCascoClaim')}</Link>
              </li>
              <li>
                <Link to="/create-claim/medical/searchApplicant">
                  {t('footer.applyMedicalClaim')}
                </Link>
              </li>
              <li>
                <Link to="/claim-status">{t('footer.compensationStatus')}</Link>
              </li>
              <li>
                <Link to="/recurring-payment/schedule">{t('footer.makePayment')}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={cn(classes.item, classes.footerActions)}>
          {/* @TODO will be open in the latter */}
          {/* <div className={classes.buttonGroup}> */}
          {/*  <ButtonGroup /> */}
          {/* </div> */}
          <div className={classes.logoSection}>
            <div className={classes.logos}>
              <div className={classes.top}>
                <a href="https://www.efes.am/%D5%AF%D5%A2">
                  <img src={CBLogo} alt="cb_logo" style={{ width: 70 }} />
                </a>
                <a href="https://www.efes.am/%D6%86%D5%B0%D5%B0">
                  <img src={FHHLogo} alt="fhh_logo" style={{ width: 50 }} />
                </a>
                <a href="https://www.efes.am/%D5%A2%D5%B5%D5%B8%D6%82%D6%80%D5%B8">
                  <img src={BureauLogo} alt="bureau_logo" style={{ width: 120, marginLeft: 10 }} />
                </a>
              </div>
              <div className={classes.bottom}>
                <a href="https://www.fininfo.am">
                  <img src={FinInfoLogo} alt="fininfo-logo" style={{ width: 90, marginTop: 10 }} />
                </a>
                <a href="https://www.abcfinance.am">
                  <img src={ABCLogo} alt="abc_logo" style={{ width: 120 }} />
                </a>
              </div>
            </div>
            <p>{t('footer.supervised')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

TopFooter.propTypes = {
  handleChangeLanguage: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
};

export default TopFooter;
